import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#how-we-think", label: "How It Works" },
  { href: "#process", label: "Our Process" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 py-5 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="font-mono text-[10px] tracking-[0.35em] text-gold uppercase">AX—01</span>
          <span className="font-display text-xl sm:text-2xl tracking-tight leading-none">
            <span className="hidden sm:inline">AXIOM PROPERTY ADVISORY</span>
            <span className="sm:hidden">AXIOM</span>
            <span className="text-gold">.</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[13px] tracking-[0.2em] uppercase text-white/70 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="tel:1300713180"
            data-testid="nav-phone"
            className="hidden lg:inline-flex items-center gap-2 text-white/75 hover:text-gold text-[11px] tracking-[0.3em] uppercase font-mono transition-colors"
          >
            <span className="h-1.5 w-1.5 bg-gold rounded-full" />
            1300 713 180
          </a>
          <a
            href="#pricing"
            data-testid="nav-cta"
            className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 border border-gold/60 text-gold text-[11px] tracking-[0.3em] uppercase hover:bg-gold hover:text-ink transition-colors"
          >
            Get Started
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-white/80"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#0A0A0A]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] uppercase text-white/80"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
